import { StateKey } from 'common/utils/flipState'
import { CommonState } from 'common/types'
import { fetchReviewIds as fetchServerGeneralReviewIds } from 'common/services/review'
import { ReviewIdsState } from 'common/types/entities/review'
import { ReviewIds, ReviewServiceType, ReviewSortType } from 'common/types/entities/api/review'

const FETCH = 'review/generalReviewIds/FETCH'

const initialState: ReviewIdsState = {
  reviewIds: [],
  totalCount: 0,
}

export const fetchGeneralReviewIds = (curState: StateKey, merchantNo: string, originProductNo: string) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const reviewIds: ReviewIds = await fetchServerGeneralReviewIds({
    merchantNo,
    originProductNo,
    reviewServiceType: ReviewServiceType.SELLBLOG,
    sortType: ReviewSortType.REVIEW_RANKING,
  })

  dispatch({
    curState,
    reviewIds: reviewIds.ids,
    type: FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        reviewIds: action.reviewIds,
      }
    default:
      return state
  }
}

export default reducer
